import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import HomeEntry from "@/pages/HomeEntry";
import Academy from "@/pages/Academy";
import LogicCourse from "@/pages/academy/logic/LogicCourse";
import LogicPhase from "@/pages/academy/logic/LogicPhase";
import LogicLesson from "@/pages/academy/logic/LogicLesson";
import RecordOfJudgment from "@/pages/academy/logic/RecordOfJudgment";
import PracticePage from "@/pages/academy/logic/PracticePage";
import PathOfPractice from "@/pages/academy/logic/PathOfPractice";
import ChamberOfJudgment from "@/pages/academy/logic/ChamberOfJudgment";
import LogicGlossary from "@/pages/academy/logic/LogicGlossary";
import MyWork from "@/pages/academy/MyWork";
import PhysicsCourse from "@/pages/academy/physics/PhysicsCourse";
import PhysicsPhase from "@/pages/academy/physics/PhysicsPhase";
import PhysicsLesson from "@/pages/academy/physics/PhysicsLesson";
import PhysicsGlossary from "@/pages/academy/physics/PhysicsGlossary";
import RecordOfReality from "@/pages/academy/physics/RecordOfReality";
import AcceptancePractice from "@/pages/academy/physics/AcceptancePractice";
import PathOfNature from "@/pages/academy/physics/PathOfNature";
import ChamberOfNatureFate from "@/pages/academy/physics/ChamberOfNatureFate";
import EthicsCourse from "@/pages/academy/ethics/EthicsCourse";
import EthicsPhase from "@/pages/academy/ethics/EthicsPhase";
import EthicsLesson from "@/pages/academy/ethics/EthicsLesson";
import EthicsGlossary from "@/pages/academy/ethics/EthicsGlossary";
import RecordOfRightAction from "@/pages/academy/ethics/RecordOfRightAction";
import EthicsPractice from "@/pages/academy/ethics/EthicsPractice";
import PathOfEthics from "@/pages/academy/ethics/PathOfEthics";
import ChamberOfRightAction from "@/pages/academy/ethics/ChamberOfRightAction";
import AdminLogicMedia from "@/pages/admin/AdminLogicMedia";
import AdminLogicCMS from "@/pages/admin/AdminLogicCMS";
import AdminPhysicsMedia from "@/pages/admin/AdminPhysicsMedia";
import AdminPhysicsCMS from "@/pages/admin/AdminPhysicsCMS";
import AdminEthicsMedia from "@/pages/admin/AdminEthicsMedia";
import AdminEthicsCMS from "@/pages/admin/AdminEthicsCMS";
import LivingLibrary from "@/pages/library/LivingLibrary";
import LibraryCategory from "@/pages/library/LibraryCategory";
import LibraryEntry from "@/pages/library/LibraryEntry";
import { getCategory } from "@/lib/libraryCategories";

// Canonical URL rule: /library/{x} is a collection hub when {x} is a known
// category id, otherwise the permanent flat address of one knowledge entity.
function LibraryHubOrEntry() {
  const { categoryId } = useParams();
  return getCategory(categoryId)
    ? <LibraryCategory />
    : <LibraryEntry key={categoryId} flatSlug={categoryId} />;
}
import LibrarySearch from "@/pages/library/LibrarySearch";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ResetPassword from "@/pages/ResetPassword";
import Support from "@/pages/Support";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import NotFound from "@/pages/NotFound";
import WaitlistAdmin from "@/pages/WaitlistAdmin";
import AIStoicCoach from "@/pages/sub/AIStoicCoach";
import WisdomCoach from "@/pages/sub/WisdomCoach";
import SelfReflectionApp from "@/pages/sub/SelfReflectionApp";
import MarcusAureliusAI from "@/pages/sub/MarcusAureliusAI";
import SenecaAI from "@/pages/sub/SenecaAI";
import EpictetusAI from "@/pages/sub/EpictetusAI";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import JournalAdmin from "@/pages/JournalAdmin";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminAutoSEO from "@/pages/admin/AdminAutoSEO";
import AdminEditorialDashboard from "@/pages/admin/AdminEditorialDashboard";
import AdminContentCalendar from "@/pages/admin/AdminContentCalendar";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminSEOCenter from "@/pages/admin/AdminSEOCenter";
import AdminAIJobs from "@/pages/admin/AdminAIJobs";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import PublishingStudio from "@/pages/admin/PublishingStudio";
import AdminLibrary from "@/pages/admin/AdminLibrary";
import AdminLexicon from "@/pages/admin/AdminLexicon";
import AdminVault from "@/pages/admin/AdminVault";
import AdminSiteMedia from "@/pages/admin/AdminSiteMedia";
import AdminStudents from "@/pages/admin/AdminStudents";
import AdminDailyInspiration from "@/pages/admin/AdminDailyInspiration";
import AdminFounders from "@/pages/admin/AdminFounders";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminDownloads from "@/pages/admin/AdminDownloads";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminSystem from "@/pages/admin/AdminSystem";
import AdminGuard from "@/components/admin/AdminGuard";
import TrainingCards from "@/pages/TrainingCards";
import ConceptPage from "@/pages/stoicism/ConceptPage";
import StoicTrainingPage from "@/pages/stoicism/StoicTrainingPage";
import AncientLibraryPage from "@/pages/ancient/AncientLibraryPage";
import SvfCollectionPage from "@/pages/ancient/SvfCollectionPage";
import SvfPhilosopherPage from "@/pages/ancient/SvfPhilosopherPage";
import ZenoVitaPage from "@/pages/ancient/ZenoVitaPage";
import CleanthesVitaPage from "@/pages/ancient/CleanthesVitaPage";
import SvfEntryPage from "@/pages/ancient/SvfEntryPage";
import Insights from "@/pages/Insights";
import Books from "@/pages/Books";
import Agora from "@/pages/Agora";
import ShareYourThoughts from "@/pages/ShareYourThoughts";
import Watch from "@/pages/Watch";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { AuthProvider } from "@/context/AuthContext";
import FoundersChoiceGate from "@/components/FoundersChoiceGate";
import MyStoicOs from "@/pages/mystoicos/MyStoicOs";
import MyJournal from "@/pages/mystoicos/MyJournal";
import StoicSettings from "@/pages/mystoicos/StoicSettings";
import OnboardingScenes from "@/pages/mystoicos/OnboardingScenes";
import NewsletterDisclosure from "@/components/NewsletterDisclosure";
import { trackPageview } from "@/lib/analytics";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { SiteMediaProvider } from "@/lib/useSiteMedia";
import { VirtueGuideProvider } from "@/components/VirtueGuideContext";
import VirtueGuideHighlighter from "@/components/VirtueGuideHighlighter";
import ErrorBoundary from "@/components/ErrorBoundary";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let anchor links scroll themselves
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function PageviewTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const path = pathname + (search || "");
    trackPageview(path, document.title);
  }, [pathname, search]);
  return null;
}

function ChromeGate({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return isAdmin ? null : children;
}

/* Hidden probe route to verify the ErrorBoundary fallback (never linked). */
function CrashProbe() {
  throw new Error("ErrorBoundary probe");
}

function NewsletterBand() {
  const { pathname } = useLocation();
  // Home Entry ends with its own newsletter card — nothing after the closing.
  if (pathname === "/") return null;
  // Article pages carry their own newsletter CTA — max one visible form there.
  if (/^\/stoic-journal\/./.test(pathname)) return null;
  // Quiet study experience: no CTA under Academy lessons and phase pages
  // (those close with the four-virtues seal instead).
  if (/^\/academy\/[^/]+\/phase\//.test(pathname)) return null;
  return <NewsletterDisclosure variant="global" />;
}

/**
 * LegacyJournalRedirect — folds the historical `/journal/:slug` path into
 * the canonical `/stoic-journal/:slug`. Kept intentionally simple: the
 * primary 301 redirect happens at the hosting layer via
 * `public/_redirects`; this component only exists so that in-app SPA
 * navigation to the legacy URL still lands on the right page.
 */
function LegacyJournalRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/stoic-journal/${slug}`} replace />;
}

function App() {
  return (
    <div className="App min-h-screen bg-ink text-bone grain">
      <ErrorBoundary>
      <LanguageProvider>
      <AuthProvider>
        <SiteMediaProvider>
        <BrowserRouter>
        <VirtueGuideProvider>
        <ScrollToTop />
        <PageviewTracker />
        <FoundersChoiceGate />
        <VirtueGuideHighlighter>
        <ChromeGate><Nav /></ChromeGate>
        <Routes>
          <Route path="/" element={<HomeEntry />} />
          <Route path="/academy" element={<Academy />} />
          <Route path="/__crash" element={<CrashProbe />} />
          <Route path="/academy/gate" element={<Navigate to="/academy" replace />} />
          <Route path="/academy/my-work" element={<MyWork />} />
          <Route path="/academy/logic" element={<LogicCourse />} />
          <Route path="/academy/logic/phase/:phaseSlug" element={<LogicPhase />} />
          <Route path="/academy/logic/phase/:phaseSlug/lesson/:lessonSlug" element={<LogicLesson />} />
          <Route path="/academy/logic/journal" element={<RecordOfJudgment />} />
          <Route path="/academy/logic/practice" element={<PracticePage />} />
          <Route path="/academy/logic/progress" element={<PathOfPractice />} />
          <Route path="/academy/logic/terms" element={<LogicGlossary />} />
          <Route path="/academy/logic/chamber-of-judgment" element={<ChamberOfJudgment />} />
          <Route path="/academy/physics" element={<PhysicsCourse />} />
          <Route path="/academy/physics/phase/:phaseSlug" element={<PhysicsPhase />} />
          <Route path="/academy/physics/phase/:phaseSlug/lesson/:lessonSlug" element={<PhysicsLesson />} />
          <Route path="/academy/physics/record" element={<RecordOfReality />} />
          <Route path="/academy/physics/practice" element={<AcceptancePractice />} />
          <Route path="/academy/physics/path" element={<PathOfNature />} />
          <Route path="/academy/physics/terms" element={<PhysicsGlossary />} />
          <Route path="/academy/physics/chamber" element={<ChamberOfNatureFate />} />
          <Route path="/academy/ethics" element={<EthicsCourse />} />
          <Route path="/academy/ethics/phase/:phaseSlug" element={<EthicsPhase />} />
          <Route path="/academy/ethics/phase/:phaseSlug/lesson/:lessonSlug" element={<EthicsLesson />} />
          <Route path="/academy/ethics/record" element={<RecordOfRightAction />} />
          <Route path="/academy/ethics/practice" element={<EthicsPractice />} />
          <Route path="/academy/ethics/path" element={<PathOfEthics />} />
          <Route path="/academy/ethics/terms" element={<EthicsGlossary />} />
          <Route path="/academy/ethics/chamber" element={<ChamberOfRightAction />} />
          <Route path="/library" element={<LivingLibrary />} />
          <Route path="/library/search" element={<LibrarySearch />} />
          <Route path="/library/:categoryId" element={<LibraryHubOrEntry />} />
          <Route path="/library/:categoryId/:slug" element={<LibraryEntry />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/support" element={<Support />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/ai-stoic-coach" element={<AIStoicCoach />} />
          <Route path="/wisdom-coach" element={<WisdomCoach />} />
          <Route path="/self-reflection-app" element={<SelfReflectionApp />} />
          <Route path="/marcus-aurelius-ai" element={<MarcusAureliusAI />} />
          <Route path="/seneca-ai" element={<SenecaAI />} />
          <Route path="/epictetus-ai" element={<EpictetusAI />} />
          <Route path="/stoic-journal" element={<Journal />} />
          <Route path="/stoic-journal/:slug" element={<JournalArticle />} />
          <Route path="/my-stoicos" element={<MyStoicOs />} />
          <Route path="/my-stoicos/journal" element={<MyJournal />} />
          <Route path="/my-stoicos/settings" element={<StoicSettings />} />
          <Route path="/my-stoicos/onboarding" element={<OnboardingScenes />} />
          <Route path="/my-stoicos/onboarding/:scene" element={<OnboardingScenes />} />
          {/*
            Legacy short-form journal URLs are folded into the canonical
            /stoic-journal/:slug route. The primary redirect happens at
            the hosting layer (public/_redirects, 301). These SPA-level
            routes are defense-in-depth for clients that reach the app
            without going through the edge (direct hits during SPA
            navigation, or prerender hits that execute JS).
          */}
          <Route path="/journal" element={<Navigate to="/stoic-journal" replace />} />
          <Route path="/journal/:slug" element={<LegacyJournalRedirect />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminGuard><AdminDashboard /></AdminGuard>} />
          <Route path="/admin/publishing-studio" element={<AdminGuard><PublishingStudio /></AdminGuard>} />
          <Route path="/admin/journal" element={<AdminGuard><JournalAdmin /></AdminGuard>} />
          <Route path="/admin/lexicon" element={<AdminGuard><AdminLexicon /></AdminGuard>} />
          <Route path="/admin/vault" element={<AdminGuard><AdminVault /></AdminGuard>} />
          <Route path="/admin/site-media" element={<AdminGuard><AdminSiteMedia /></AdminGuard>} />
          <Route path="/admin/students" element={<AdminGuard><AdminStudents /></AdminGuard>} />
          <Route path="/admin/daily-inspiration" element={<AdminGuard><AdminDailyInspiration /></AdminGuard>} />
          <Route path="/admin/founders" element={<AdminGuard><AdminFounders /></AdminGuard>} />
          <Route path="/admin/academy-logic-media" element={<AdminGuard><AdminLogicMedia /></AdminGuard>} />
          <Route path="/admin/academy-logic" element={<AdminGuard><AdminLogicCMS /></AdminGuard>} />
          <Route path="/admin/academy-physics-media" element={<AdminGuard><AdminPhysicsMedia /></AdminGuard>} />
          <Route path="/admin/academy-physics" element={<AdminGuard><AdminPhysicsCMS /></AdminGuard>} />
          <Route path="/admin/academy-ethics-media" element={<AdminGuard><AdminEthicsMedia /></AdminGuard>} />
          <Route path="/admin/academy-ethics" element={<AdminGuard><AdminEthicsCMS /></AdminGuard>} />
          <Route path="/admin/library" element={<AdminGuard><AdminLibrary /></AdminGuard>} />
          <Route path="/admin/autoseo" element={<AdminGuard><AdminAutoSEO /></AdminGuard>} />
          <Route path="/admin/autoseo/import-status" element={<Navigate to="/admin/editorial?tab=autoseo" replace />} />
          <Route path="/admin/editorial" element={<AdminGuard><AdminEditorialDashboard /></AdminGuard>} />
          <Route path="/admin/content-calendar" element={<AdminGuard><AdminContentCalendar /></AdminGuard>} />
          <Route path="/admin/newsletter" element={<AdminGuard><AdminNewsletter /></AdminGuard>} />
          <Route path="/admin/seo-center" element={<AdminGuard><AdminSEOCenter /></AdminGuard>} />
          <Route path="/admin/ai-jobs" element={<AdminGuard><AdminAIJobs /></AdminGuard>} />
          <Route path="/admin/analytics" element={<AdminGuard><AdminAnalytics /></AdminGuard>} />
          <Route path="/admin/downloads" element={<AdminGuard><AdminDownloads /></AdminGuard>} />
          <Route path="/admin/messages" element={<AdminGuard><AdminMessages /></AdminGuard>} />
          <Route path="/admin/settings" element={<AdminGuard><AdminSettings /></AdminGuard>} />
          <Route path="/admin/system" element={<AdminGuard><AdminSystem /></AdminGuard>} />
          <Route path="/stoic-training-cards" element={<TrainingCards />} />
          <Route path="/stoic-training-cards/:slug" element={<TrainingCards />} />
          <Route path="/stoicism/:slug" element={<ConceptPage />} />
          <Route path="/stoic-training/:slug" element={<StoicTrainingPage />} />
          <Route path="/ancient-library" element={<AncientLibraryPage />} />
          <Route path="/ancient-library/svf" element={<SvfCollectionPage />} />
          <Route path="/ancient-library/svf/zeno/vita" element={<ZenoVitaPage />} />
          <Route path="/ancient-library/svf/cleanthes/vita" element={<CleanthesVitaPage />} />
          <Route path="/ancient-library/svf/:philosopher" element={<SvfPhilosopherPage />} />
          <Route path="/ancient-library/svf/:philosopher/:slug" element={<SvfEntryPage />} />
          <Route path="/my-insights" element={<Insights />} />
          <Route path="/my-books" element={<Books />} />
          <Route path="/agora" element={<Agora />} />
          <Route path="/watch" element={<Watch />} />
          <Route path="/share-your-thoughts" element={<ShareYourThoughts />} />
          <Route path="/admin/waitlist" element={<WaitlistAdmin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ChromeGate><NewsletterBand /></ChromeGate>
        <ChromeGate><Footer /></ChromeGate>
        </VirtueGuideHighlighter>
        </VirtueGuideProvider>
        </BrowserRouter>
        </SiteMediaProvider>
      </AuthProvider>
      </LanguageProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
